export enum DateFormat {
  FullDate = "MMMM D, YYYY",
  ShortDate = "MMM D",
  User = "YYYY-MM-DD",
  Time = "h:mm A",
  Year = "YYYY",
}
